import { Link } from 'react-router-dom';
import type { MarketplaceProduct } from '@isbd/shared';
import { MARKETPLACE_PLACEHOLDER_PHOTO, MAX_PREMIUM_PRODUCTS } from '@isbd/shared';
import { useI18n } from '@/features/i18n/I18nProvider';

function formatPrice(value: number, currency: string) {
  return `${Number(value).toLocaleString('fr-FR', { maximumFractionDigits: 2 })}${currency}`;
}

export function PremiumBanner({ products }: { products: MarketplaceProduct[] }) {
  const { t } = useI18n();
  const slot = products.slice(0, MAX_PREMIUM_PRODUCTS);

  if (!slot.length) {
    return (
      <div className="mp-premium">
        <div className="mp-premium-inner">
          <div className="mp-premium-copy">
            <span className="mp-badge">★ {t('premium.badge')}</span>
            <h2>{t('premium.title')}</h2>
            <p>{t('premium.empty')}</p>
          </div>
        </div>
      </div>
    );
  }

  const featured = slot.find((p) => p.is_featured) ?? slot[0];
  const others = slot.filter((p) => p.id !== featured.id).slice(0, 4);
  const currency = featured.currency || '€';

  return (
    <div className="mp-premium">
      <div className="mp-premium-inner">
        <div className="mp-premium-copy">
          <span className="mp-badge">★ {t('premium.badge')}</span>
          <h2>{t('premium.title')}</h2>
          <p>{t('premium.empty')}</p>
          <Link to={`/marketplace/${featured.id}`} className="btn btn-accent mp-premium-cta">
            {t('premium.cta')}
          </Link>
        </div>

        <div className="mp-premium-mosaic">
          <Link to={`/marketplace/${featured.id}`} className="mp-premium-feat">
            <img
              src={featured.photo_urls?.[0] || MARKETPLACE_PLACEHOLDER_PHOTO}
              alt={featured.name}
            />
            <div className="mp-premium-feat-shade" aria-hidden />
            <div className="mp-premium-feat-copy">
              <strong>{featured.name}</strong>
              <span>{formatPrice(Number(featured.price), currency)}</span>
            </div>
          </Link>
          {others.map((p) => (
            <Link key={p.id} to={`/marketplace/${p.id}`} className="mp-premium-thumb">
              <img src={p.photo_urls?.[0] || MARKETPLACE_PLACEHOLDER_PHOTO} alt={p.name} />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
